import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const SITE = 'https://hybrid-training-club.com';

// Per-route SEO (title + meta description + canonical), applied client-side.
const SEO = {
  '/': {
    title: "Hyrox Toulouse & Colomiers — Hybrid Training Club | Salle d'Hyrox",
    description:
      "Salle d'Hyrox à Toulouse (Ponts-Jumeaux) et Colomiers. Préparation Hyrox, cours tous niveaux, coaching expert. Séance d'essai offerte, 1 abo pour 2 salles dès 29 €/mois.",
  },
  '/lhyrox': {
    title: "C'est quoi l'Hyrox ? Les 8 stations expliquées — Hybrid Training Club",
    description:
      "Découvre l'Hyrox : 8 stations, 8 km de course. On t'explique chaque épreuve et on te prépare à Toulouse et Colomiers, tous niveaux.",
  },
  '/nos-cours': {
    title: "Nos cours Hyrox tous niveaux — Hybrid Training Club Toulouse & Colomiers",
    description:
      "Hyrox Full, Strength, Run, Rox, Open Gym, Team WOD : des cours encadrés par des coachs experts à Toulouse et Colomiers. Séance d'essai offerte.",
  },
  '/equipe': {
    title: "L'équipe de coachs Hyrox — Hybrid Training Club",
    description:
      "Rencontre les coachs d'Hybrid Training Club. Une équipe passionnée pour te faire progresser sur l'Hyrox à Toulouse et Colomiers.",
  },
  '/tarifs': {
    title: "Tarifs Hyrox dès 29 €/mois — Hybrid Training Club Toulouse & Colomiers",
    description:
      "Abonnements Hyrox dès 29 €/mois avec accès aux 2 salles, carnets de séances et séance d'essai offerte, sans engagement.",
  },
  '/contact': {
    title: "Réserve ta séance d'essai gratuite — Hybrid Training Club",
    description:
      "Réserve ta première séance d'Hyrox gratuitement à Toulouse ou Colomiers. Un coach te recontacte sous 24 h, sans engagement.",
  },
};

const CLUB_SEO = {
  '/club/toulouse': {
    title: "Hyrox Toulouse — Hybrid Training Club | 8 stations officielles",
    description:
      "Salle d'Hyrox au cœur de Toulouse (Ponts-Jumeaux) : 8 stations officielles, coaching illimité, vestiaires. Séance d'essai offerte.",
  },
  '/club/colomiers': {
    title: "Hyrox Colomiers — Hybrid Training Club | Ton box Hyrox",
    description:
      "Salle d'Hyrox à Colomiers : 8 stations officielles, parking gratuit, coaching illimité. Séance d'essai offerte.",
  },
};

function applySeo(pathname) {
  const data = CLUB_SEO[pathname] || SEO[pathname] || SEO['/'];
  document.title = data.title;

  const setMeta = (selector, attr, value, create) => {
    let el = document.head.querySelector(selector);
    if (!el && create) {
      el = create();
      document.head.appendChild(el);
    }
    if (el) el.setAttribute(attr, value);
  };

  setMeta('meta[name="description"]', 'content', data.description, () => {
    const m = document.createElement('meta');
    m.setAttribute('name', 'description');
    return m;
  });
  setMeta('meta[property="og:title"]', 'content', data.title);
  setMeta('meta[property="og:description"]', 'content', data.description);
  setMeta('meta[property="og:url"]', 'content', `${SITE}${pathname}`);
  setMeta('link[rel="canonical"]', 'href', `${SITE}${pathname}`, () => {
    const l = document.createElement('link');
    l.setAttribute('rel', 'canonical');
    return l;
  });
}

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    applySeo(pathname);
  }, [pathname]);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
